<template>
  <div>
    <v-snackbar color="deep-orange"
                right
                top
                v-model="validationSnackbar">
      {{ $t('thereAreItemsThatRequireYourAttention') }}
    </v-snackbar>

    <top-header v-bind:title="$t('newLearningTenant')">
      <header-button icon="mdi-close"
                     slot="left-button"
                     v-bind:label="$t('cancel')"
                     v-bind:to="{ name: 'learning-tenants' }" />
      <header-button icon="mdi-check"
                     right
                     slot="right-button"
                     v-bind:label="$t('save')"
                     v-on:click="createLearningTenant" />
    </top-header>

    <v-progress-linear indeterminate
                       v-bind:active="loading" />

    <v-container>
      <v-row>
        <v-col cols="12"
               lg="6">
          <learningTenant-details-card ref="learningTenantDetailsCard"
                                v-bind:learningTenant="learningTenant" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  import HeaderButton from '@/components/common/HeaderButton.vue'
  import TopHeader from '@/components/common/TopHeader.vue'
  import LearningTenantDetailsCard from '@/components/learning/LearningTenantDetailsCard.vue'

  export default {
    components: {
      HeaderButton,
      LearningTenantDetailsCard,
      TopHeader
    },
    data: () => ({
      loading: false,
      learningTenant: {},
      validationSnackbar: false
    }),
    methods: {
      async createLearningTenant() {
        if (!this.$refs.learningTenantDetailsCard.validate()) {
          this.validationSnackbar = true

          return
        }

        await this.doCreateLearningTenant({ learningTenant: this.learningTenant })

        this.$router.push({ name: 'learning-tenants' })
      },
      ...mapActions({
        doCreateLearningTenant: 'learning/createLearningTenant'
      })
    },
    name: 'LearningTenantAdd'
  }
</script>

<i18n>
  {
    "de": {
      "cancel": "Abbrechen",
      "newLearningTenant": "Neuer Mandant",
      "save": "Speichern",
      "thereAreItemsThatRequireYourAttention": "Es gibt Felder, die Ihre Aufmerksamkeit erfordern."
    },
    "en": {
      "cancel": "Cancel",
      "newLearningTenant": "New temamt",
      "save": "Save",
      "thereAreItemsThatRequireYourAttention": "There are items that require your attention."
    }
  }
</i18n>